import AbstractSpecification from "../specification/AbstractSpecification.js";

/**
 * `dimensionSpecification` is a concrete implementation
 * of `abstractSpecification` representing a server side
 * specification of a dimension.
 *
 * @param {string} spec.dimensionId - Dimension id
 */
export default class DimensionSpecification extends AbstractSpecification {
	constructor({ dimensionId }) {
		super(...arguments);
		this._dimensionId = dimensionId;
	}

	getDimensionId() {
		return this._dimensionId;
	}

	accept(visitor) {
		return visitor.visitDimensionSpecification(this);
	}

	isLeaf() {
		return true;
	}

	_serializedProperties() {
		const schema = super._serializedProperties();

		schema.dimensionId = this._dimensionId;

		return schema;
	}

	static getType() {
		return "DimensionSpecification";
	}
}
